import { memo } from 'react';

const PanelNote = ({ children, tone = 'muted', centered = false, className = '' }) => {
  if (!children) {
    return null;
  }

  const toneClass = ` panel-note--${tone}`;
  const centeredClass = centered ? ' panel-note--centered' : '';
  const extraClass = className ? ` ${className}` : '';

  return (
    <div className={`panel-note${toneClass}${centeredClass}${extraClass}`}>
      {children}
    </div>
  );
};

export default memo(PanelNote);
